import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, role }) => {
  const token = useSelector((state) => state.auth.jwtToken);
  const userRole = useSelector((state) => state.auth.role);
  const allowedRoles = Array.isArray(role) ? role : [role];

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default ProtectedRoute;
